export const FETCH_DELETE_PROJECT_REQUEST = 'FETCH_DELETE_PROJECT_REQUEST'
export const FETCH_DELETE_PROJECT_SUCCESS = 'FETCH_DELETE_PROJECT_SUCCESS'
export const FETCH_DELETE_PROJECT_FALUIRE = 'FETCH_DELETE_PROJECT_FALUIRE'
